export default "__VITE_ASSET__BwthhsgA__"